import React, { Component, useEffect, useState, useRef, createRef, useCallback } from 'react'
import {
    Box,
    Stack,
    Alert
} from '@mui/material'
import * as Loaders from '../../components/UIComponents/Loader'
import * as Icons from '../../components/UIComponents/Icons'
import * as Buttons from '../../components/UIComponents/Button'
import * as Texts from '../../components/UIComponents/Text'
import * as Forms from '../../components/UIComponents/Form'
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';

import AddIcon from '@mui/icons-material/Add';
import CloseIcon from '@mui/icons-material/Close';
import Button from '@mui/material/Button';

import Autocomplete from '@mui/material/Autocomplete'
import TextField from '@mui/material/TextField'

import { v4 as uuidv4 } from 'uuid';


/**
    inputJson should contain key:value pair
    for instance:
    const inputJsonArr = [
        {
            type: "Creative",
            detail: "Laura is artistic and enjoys drawing when she feels stable."
        }
    ]
 */

const debounce = (func, delay) => {
    let timeoutId;
    return function(...args) {
        clearTimeout(timeoutId);
        timeoutId = setTimeout(() => {
            func.apply(this, args);
        }, delay);
    };
};

const KeyValuePairs = ({
    inputJsonArr,
    targetTheme,
    maxArr = 6,
    onUpdateArr, 
    typeLabel = "Type",
    detailLabel = "Detail",
    maxWarning = "",
    deleteWarning = "",
    cancelText="Cancel",
    yesText="Yes",
    predefinedTypes = [],
    useAutocomplete = false,
    isMultiline = false,
}) => {
    // console.log("got input json arr", inputJsonArr)
    const idMapRef = useRef(new Map());
    const [internalArr, updateInternalArr] = useState(inputJsonArr || [])
    const [alertOpen, setAlertOpen] = useState(false)
    const [dialogueOpen, setDialogueOpen] = useState(false)
    const [indexToRemove, setIndexToRemove] = useState(null)
    const [error, setError] = useState({})
    const prevInputJsonArrRef = useRef()

    // console.log(`the target theme is ${targetTheme}`)
    const handleCloseDialogue = () => {
        setDialogueOpen(false)
    }

    const handleRemove = (index) => {
        setIndexToRemove(index); // Store the index of the item to be removed
        // console.log(`index to remove is ${index}`)
        setDialogueOpen(true);   // Open the dialog
    };

    const confirmRemove = () => {
        if (indexToRemove !== null) {
            const newInputJsonArr = [...internalArr];
            newInputJsonArr.splice(indexToRemove, 1);

            // const removedItem = internalArr[indexToRemove];
            // if (removedItem && (removedItem.type !== '' || removedItem.detail !== '')) {
            //     const removedItemKey = JSON.stringify({ type: removedItem.type, detail: removedItem.detail });
            //     if (idMapRef.current.has(removedItemKey) && idMapRef.current.get(removedItemKey) === removedItem.id) {
            //         idMapRef.current.delete(removedItemKey);
            //     }
            // }

            //CHECK! Is this feature still needed?
            // if (newInputJsonArr.length === 0) {
            //     newInputJsonArr.push({ id: uuidv4(), type: "", detail: "" });
            // }

            updateInternalArr(newInputJsonArr); // Update the state
            // console.log(`after update `, newInputJsonArr)
            setIndexToRemove(null);  // Reset the index to avoid accidental deletion
            // send the new array to the parent component to update the central state
            onUpdateArr(newInputJsonArr)
        }
        handleCloseDialogue()  // Close the dialog after confirming
    }

    const clearError = (field,  index) => {
        setError((prevErrors) => {
            const updatedErrors = { ...prevErrors }
            if (updatedErrors[index]) {
                delete updatedErrors[index][field]
                if (Object.keys(updatedErrors[index]).length === 0) {
                    delete updatedErrors[index]
                }
            }
            return updatedErrors
        })
        
    }

    const handleBlur = (field, value, index) => {
        if(!value){
            setError((prevErrors) => {
                const updatedErrors = { ...prevErrors }
                
                if (!updatedErrors[index]) {
                    updatedErrors[index] = {}
                }

                updatedErrors[index][field] = "入力してください"
                return updatedErrors
            })
        }
    }

    const debouncedOnUpdateArr = useCallback(
        debounce((newArr) => {
            Promise.resolve().then(() => {
                onUpdateArr(newArr);
            })
        }, 500),
        [onUpdateArr]
    )

    useEffect(() => {
        if (JSON.stringify(inputJsonArr || []) === JSON.stringify(internalArr)) {
            return;
        }

        // if users have not indicated any personality type, you can add one to get them started
        let newInternalArr = [];
        if (!inputJsonArr || inputJsonArr.length === 0){
            newInternalArr = [{ id: uuidv4(), type: "", detail: "" }]
        } else {
            newInternalArr = inputJsonArr.map(item => {
                return item.id ? item : { ...item, id: uuidv4() };
            })
            const currentKeysInMap = new Set(idMapRef.current.keys())
            const newItemKeys = new Set(newInternalArr.filter(item => item.type !== '' || item.detail !== '').map(item => JSON.stringify({ type: item.type, detail: item.detail })));
            for (const oldKey of currentKeysInMap) {
                if (!newItemKeys.has(oldKey)) {
                    idMapRef.current.delete(oldKey)
                }
            }
        }
        //  console.log("KeyValuePairs - top useEffect triggered. inputJsonArr (prop):", inputJsonArr);
        updateInternalArr(newInternalArr)
        // console.log("KeyValuePairs - top useEffect: updated internalArr state to:", newInternalArr);

        prevInputJsonArrRef.current = inputJsonArr
    }, [inputJsonArr], [internalArr])

    let unitArr = []
    internalArr.forEach((inputJson, idx) => {
        if (!inputJson || !inputJson.id) {
            console.warn("KeyValuePairComponent: Found invalid item in internalArr. Skipping.", inputJson);
            return;
        }
        unitArr.push(<KeyValueUnit
            key={`keyvalue-unit-${inputJson.id}`}
            index={idx}
            maxArr={maxArr || 6}
            inputJson={inputJson}
            // typeLabel={`${targetTheme} Type`}
            // detailLabel={`${targetTheme} Detail`}
            error={ error[idx] || {} }
            handleBlur={handleBlur}           
            clearError={clearError}
            typeLabel={typeLabel || `Type`}
            detailLabel={detailLabel || `Detail`}
            predefinedTypes={predefinedTypes}
            handleUpdate={(index, newInputJson) => {
                let newInputJsonArr = [...internalArr]
                const oldItem = newInputJsonArr[index]
                if (!oldItem) {
                   return
                }
                newInputJsonArr[index] = newInputJson

                // const oldKey = JSON.stringify({ type: oldItem.type, detail: oldItem.detail })
                // const newKey = JSON.stringify({ type: newInputJson.type, detail: newInputJson.detail })

                // if (oldKey !== newKey) {
                //     if ((oldItem.type !== '' || oldItem.detail !== '') && idMapRef.current.has(oldKey)) {
                //         idMapRef.current.delete(oldKey);
                //     }
                //     if (newInputJson.type !== '' || newInputJson.detail !== '') {
                //         idMapRef.current.set(newKey, newInputJson.id)
                //     }
                // }

                updateInternalArr(newInputJsonArr)
                // debouncedOnUpdateArr(newInputJsonArr)
                onUpdateArr(newInputJsonArr)
            }}
            handleRemove={handleRemove} // Pass the index to the handleRemove function
            useAutocomplete={useAutocomplete}
            isMultiline={isMultiline}
        />)
    })
    return <React.Fragment>
        <Stack
            direction={"column"}
            spacing={{
                xs: 4,
                md: 4
            }}
        >
            {unitArr}
            {internalArr.length < maxArr && <Buttons.Icon
                icon={<AddIcon />}
                onClick={() => {
                    let newInputJsonArr = [...internalArr]
                    if (newInputJsonArr.length >= maxArr) {
                        setAlertOpen(true);
                        return;
                    }
                    const newId = uuidv4();
                    const newItem = { id: newId, type: "", detail: "" };
                    newInputJsonArr.push(newItem);
                    // idMapRef.current.set(JSON.stringify({ type: "", detail: "" }), newId);
                    updateInternalArr(newInputJsonArr);
                    onUpdateArr(newInputJsonArr);
                }}
            ></Buttons.Icon>}
            {alertOpen && <Alert
                severity="warning"
                action={
                    <Buttons.Icon
                        aria-label="close alert"
                        color="inherit"
                        size="small"
                        onClick={() => {
                            setAlertOpen(false);
                        }}
                        icon={<CloseIcon fontSize="inherit" />}
                    />
                }
            >
                {maxWarning.replace("${maxArr}", maxArr)
                    .replace("${targetTheme}", targetTheme) || `You are only allowed to add up to ${maxArr} types of ${targetTheme}`}
            </Alert>}
            <Dialog
                open={dialogueOpen}
                onClose={handleCloseDialogue}
                aria-labelledby="confirm-dialog-title"
            // aria-describedby="confirm-dialog-description"
            >
                <DialogContent>
                    <DialogContentText
                        id="alert-dialog-description"
                        sx={{
                            color: "primary.dark"
                        }}
                    >
                        {deleteWarning.replace("${targetTheme}", targetTheme)
                            || `You are about to remove this ${targetTheme} description. Are you sure?`}
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleCloseDialogue}>{cancelText || "Cancel"}</Button>
                    <Button onClick={confirmRemove} autoFocus>
                        {yesText || "Yes"}
                    </Button>
                </DialogActions>
            </Dialog>

        </Stack>
    </React.Fragment>
}

const KeyValueUnit = ({
    index,
    inputJson,
    handleUpdate,
    handleBlur,
    clearError,
    error,
    handleRemove,
    typeLabel,
    detailLabel,
    predefinedTypes = [],
    useAutocomplete,
    isMultiline
}) => {
    const [type, updateType] = useState("")
    const [detail, updateDetail] = useState("")
    const [inputValue, updateInputValue] = useState("");

    useEffect(() => {
        // check if both sections are provided and the json format is correct
        if (inputJson && inputJson.hasOwnProperty("type") && inputJson.hasOwnProperty("detail")) {
            // console.log("input json type is", inputJson.type)
            updateType(inputJson.type || "")
            updateDetail(inputJson.detail || "")
            updateInputValue(inputJson.type || "")
        }
        // console.log("[useEffect] inputJsonArr ===>", inputJson)
    }, [inputJson])
    return (<React.Fragment>
        <Stack
            spacing={{
                xs: 0
            }}
            direction={'row'}
            alignItems={"center"}
        >
            <Stack
                spacing={{
                    xs: 1,
                    md: 2
                }}
                direction={{
                    xs: "column",
                    md: "column"
                }}
                sx={{
                    flex: 1
                }}
            >
                <Box
                    sx={{
                        flex: .3
                    }}
                >
                    {useAutocomplete ? (
                        <Autocomplete
                            disablePortal
                            freeSolo
                            options={predefinedTypes || []}
                            value={type ?? ""}
                            inputValue={inputValue ?? ""}
                            onChange={(event, newValue) => {
                                updateType(newValue)
                                updateInputValue(newValue)
                                let newJson = { ...inputJson, type: newValue }
                                handleUpdate(index, newJson)
                                clearError("type", index)
                            }}
                            onInputChange={(event, newInputValue) => {
                                updateInputValue(newInputValue)
                                clearError("type", index)
                            }}
                            renderInput={(params) => (
                                <TextField
                                    {...params}
                                    label={typeLabel || 'Personality Type'}
                                    error={!!error.type}
                                    helperText={error.type || ''}
                                />
                            )}
                            onBlur={(e) => {
                                const currentInputValue = e.target.value
                                updateType(currentInputValue)
                                updateInputValue(currentInputValue)
                                if (currentInputValue !== (inputJson.type || '')) {
                                    let newJson = { ...inputJson, type: currentInputValue }
                                    handleUpdate(index, newJson)
                                }
                                handleBlur("type", currentInputValue, index)
                            }}
                            // error={error.type || ""}
                        />
                    ) : (
                        <Forms.TextInput
                            type="text"
                            label={typeLabel || 'Personality Type'}
                            aria-label={typeLabel.toLowerCase() || 'personality type'}
                            icon="envelope"
                            onChange={(e) => {
                                updateType(e.target.value)
                                let newJson = { ...inputJson, type: e.target.value }
                                handleUpdate(index, newJson)
                                clearError("type", index)
                            }}
                            onBlur={(e) => handleBlur("type", e.target.value, index)}
                            value={type}
                            error={error.type || ""}
                        />
                    )}
                </Box>
                <Texts.Paragraph
                    sx={{
                        display: {
                            xs: "none",
                            md: "none"
                        }

                    }}
                    direction={{
                        xs: "column",
                        md: "column"
                    }}
                >:</Texts.Paragraph>
                <Box
                    sx={{
                        flex: 1,
                    }}
                >
                     {isMultiline ? (
                        <Forms.TextArea 
                        // label={detailLabel || 'Personality Detail'}
                        smallLabel = {detailLabel || 'Personality Detail'}
                        aria-label={(detailLabel || 'personality detail').toLowerCase()}
                        onChange={(e) => {
                            updateDetail(e.target.value);
                            clearError("detail", index);
                        }}
                        onBlur={(e) => {
                            handleBlur("detail", e.target.value, index);
                            handleUpdate(index, { ...inputJson, detail: e.target.value });
                        }}
                        value={detail}
                        error={!!error.detail}
                        />
                    ) :(
                        <Forms.TextInput
                            // ref={_story}
                            type={"text"}
                            // type={this.state.hidePass ? "password" : "text"}
                            label={detailLabel || 'Personality Detail'}
                            aria-label={detailLabel.toLowerCase() || 'personality detail'}
                            icon='envelope'
                            onChange={(e) => {
                                updateDetail(e.target.value)
                                clearError("detail", index)
                            }}
                                onBlur={(e) => {
                                handleBlur("detail", e.target.value, index)
                                handleUpdate(index, { ...inputJson, detail: e.target.value })
                            }}
                            value={detail}
                            // error={error.detail || ""} 
                            // helperText="Tell us what kind of a person you want the agent to represent."
                        />
                    )}
                </Box>

            </Stack>
            <Box
                sx={{
                    // flex: .2,
                    width: 40,
                    height: 40,
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: "center"
                }}
            >
                <Buttons.Icon
                    icon={<Icons.DeleteIcon style={{
                        width: '36px',
                        height: '36px'
                    }} />}
                    onClick={() => handleRemove(index)}
                />
            </Box>
        </Stack>
    </React.Fragment>)

}

export default KeyValuePairs